import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AnimatedLink } from '../components/animated-link/AnimatedLink';
import { NavButtonize } from './NavButtonize';

export const NavToDoctrine: FC = () => (
  <NavButtonize noMobile>
    <AnimatedLink href="/" source="marketing_header">
      <span>
        <FormattedMessage id="navigation/NavToDoctrine.tsx/1" />
      </span>
    </AnimatedLink>
  </NavButtonize>
);
